<template>
  <nuttrema-layout-content>

    <template slot="header">
      <stuff-to-eat-standard-header
        :meta="meta"
        :showEdit="true"
        :edit.sync="edit"
        :editDisabled="!setManually"
        :StuffToEatDetails="StuffToEatDetails">
      </stuff-to-eat-standard-header>
    </template>

    <template slot="central">
      <page-labels-popover
         v-if="showPageLabelsPopover"
        :id="id"
        :type="type"
        :permissions="_get(StuffToEatDetails, 'meta.permissions')"
        :servingSizeID="servingSizeID"
        @close="handleClosePageLabelsPopover">
      </page-labels-popover>

      <nuttrema-loader v-if="loading"></nuttrema-loader>
      <form-food-product-nutrition-information
         v-else
        :type="type"
        :edit.sync="edit"
        :showManually="showManually"
        :setManually.sync="setManually"
        :StuffToEatDetails="StuffToEatDetails"
        :StuffToEatNutritionFactsLabel="StuffToEatNutritionFactsLabel"
        :StuffToEatNutritionInformation="StuffToEatNutritionInformation"
        :productNutritionInformation="StuffToEatNutritionInformation.data"
        @downloadPDF="onDownloadPDF"
        @changeManualControl="onChangeManualControl"
        @submit="onFormSubmit">
      </form-food-product-nutrition-information>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { get } from 'lodash';

import { mapActions } from 'vuex';

import { STUFF_TO_EAT_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';
import PageLabelsPopover from 'components/pages/professional/stuff-to-eat/shared/details/labels/page-labels-popover';


import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';

import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import FormFoodProductNutritionInformation from './form-food-product-nutrition-information';

export default {
  name: 'page-stuff-to-eat-nutrition-information',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
  },
  components: {
    PageLabelsPopover,
    NuttremaLayoutContent,
    StuffToEatStandardHeader,
    FormFoodProductNutritionInformation,
  },
  data() {
    return {
      edit: false,
      showEdit: false,
      setManually: false,
      showManually: true,
      servingSizeID: null,
      showPageLabelsPopover: false,
    };
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatNutritionInformation() {
      return this.$store.getters.StuffToEatNutritionInformation(this.id);
    },
    StuffToEatNutritionFactsLabel() {
      return this.$store.getters.StuffToEatNutritionFactsLabel(this.id);
    },
    loading() {
      return this.StuffToEatDetails.fetching || this.StuffToEatNutritionInformation.fetching || this.StuffToEatNutritionFactsLabel.fetching;
    },
  },
  methods: {
    ...mapActions([
      'SaveStuffToEatNutritionInformation',
      'SetNutritionInformationManualControl',
    ]),
    fetchStuffToEatData() {
      this.$store.dispatch('GetStuffToEatNutritionInformation', { type: this.type, id: this.id });
      this.$store.dispatch('GetStuffToEatNutritionFactsLabel', { id: this.id });
    },
    handleToggleWest() {
      this.showWest = !this.showWest;
    },
    onFormSubmit(data) {
      return this.SaveStuffToEatNutritionInformation({ id: this.id, type: this.type, data })
        .then(() => {
          this.successNotification({ label: 'label.nutrition_information' });
        }).catch(() => {
          this.errorNotification({ label: 'label.nutrition_information' });
        });
    },
    onChangeManualControl(value) {
      console.log('setManually', value);
      this.$store.dispatch('SetNutritionInformationManualControl', {
        id: this.id,
        type: this.type,
        payload: {
          manual_nutrition: value,
        },
      });
    },
    onDownloadPDF(servingSizeID) {
      this.servingSizeID = servingSizeID;
      this.showPageLabelsPopover = true;
    },
    handleClosePageLabelsPopover() {
      this.servingSizeID = null;
      this.showPageLabelsPopover = false;
    },
  },
  watch: {
    id() {
      this.fetchStuffToEatData();
    },
  },
  created() {
    this.fetchStuffToEatData();
    this.setManually = get(this.StuffToEatDetails, 'data.manual_nutrition', false);

    if (this.type === STUFF_TO_EAT_KEYS.food_product) {
      this.showManually = false;
    }
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatNutritionInformation', { id: this.id });
    this.$store.dispatch('ClearStuffToEatNutritionFactsLabel', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/nutrition-information/page-stuff-to-eat-nutrition-information.vue